import { h, Component } from 'preact';

import { configure } from '../../../config';

import { Placeholder } from '../placeholder';
import style from './styles.less';

/** Creates div for sadlib ad insertion
 */
@configure([
	'singleCube.usePlaceholders'
])
export class SadlibAd extends Component {

	render({ id, usePlaceholders, type, label='Ad', restrictWidth }) {
		if (usePlaceholders) {
			if (restrictWidth) {
				return (
					<div class={style.restictWidth}>
						<Placeholder id={id} type={type} label={label} />
					</div>
				);
			}

			return <Placeholder id={id} type={type} label={label} />;
		}

		if (restrictWidth) {
			return (
				<div class={style.restictWidth}>
					<div id={id} />
				</div>
			);
		}
		return <div id={id} />;
	}
}
